<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col-12 mb-2 p-0">
        <img src="/img/mrm_sistema_logo.png" alt="Logo" style="width: 160px;" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-10 ml-auto mr-auto">
        <card class="card-white text-left">
          <div slot="header">
            <h1 class="card-title text-center text-primary mb-4">Política de Privacidade</h1>
          </div>
          <div class="content p-4">
            <div class="definitions mb-4">
              <h4 class="text-dark">Das definições</h4>
              <p>
                <strong>REP671 (gênero masculino):</strong> refere-se à empresa M. R. Mendes Informática ME e sua respectiva razão social; e <strong>REP671 (gênero masculino):</strong> refere-se ao Software desenvolvido pela empresa supracitada e disponibilizado no site <a href="http://www.cartaodepontomrm.com.br" target="_blank">http://www.cartaodepontomrm.com.br</a> e em aplicativos de dispositivo móvel.
              </p>
            </div>

            <section class="mb-4">
              <h4 class="text-dark">1. Da privacidade</h4>
              <p>
                1.1. A Política de Privacidade da REP671 garante, por meio da tecnologia de criptografia “secure socket layer” (SSL), segurança e privacidade dos dados pessoais, que serão utilizados apenas no sentido de tornar a experiência com o nosso site a mais produtiva e agradável possível.
              </p>
              <p>
                1.2. A plataforma pertencente à REP671 adota os níveis legalmente requeridos quanto à segurança na proteção de dados elencados pela LGPD – Lei Geral de Proteção de Dados – Lei 13.709/2018, com respectivo tratamento de informação e utilização de todos os meios e medidas técnicas para inibição da perda, mau uso, alteração, acesso não autorizado ou subtração indevida dos dados pessoais recolhidos. Não obstante, o usuário deve estar ciente de que as medidas de segurança relativas à Internet não são integralmente infalíveis.
              </p>
              <p>
                1.3. A presente empresa reserva-se ao direito de modificar a Política de Privacidade para adaptá-la a alterações legislativas ou jurisprudenciais, ou àquelas relativas às práticas comerciais. Em qualquer caso, as mudanças serão anunciadas por meio do site <a href="https://cartaodepontomrm.com.br/" target="_blank">https://cartaodepontomrm.com.br/</a>, sendo as mudanças introduzidas com uma antecedência razoável à sua colocação em prática.
              </p>
              <p>
                1.4. A plataforma da WEB ou o aplicativo de dispositivo móvel poderão fornecer acesso a links para outros sites externos cujos conteúdos e Políticas de Privacidade, bem como segurança da informação, não são de responsabilidade da REP671. Por isso, recomenda-se aos usuários que, ao serem redirecionados para sites externos, consultem sempre as respectivas Políticas de Privacidade antes de fornecerem seus dados.
              </p>
            </section>

            <section class="mb-4">
              <h4 class="text-dark">2. Advertência</h4>
              <p>
                2.1. A navegação, o registo e o uso do software REP671 depende da aceitação das condições previstas nesta política. Recomenda-se o abandono do site ou do aplicativo caso haja discordância desta.
              </p>
            </section>

            <section class="mb-4">
              <h4 class="text-dark">3. Tratamento de dados pessoais</h4>
              <p>
                3.1. Com o seu consentimento, o REP671 pode recolher, entre outros, os seguintes dados pessoais dos Usuários que sejam pessoas físicas:
              </p>
              <ul class="list-unstyled pl-4">
                <li><i class="tim-icons icon-check-2 text-success mr-2"></i> Nome;</li>
                <li><i class="tim-icons icon-check-2 text-success mr-2"></i> Biometria Facial;</li>
                <li><i class="tim-icons icon-check-2 text-success mr-2"></i> Localização GPS;</li>
                <li><i class="tim-icons icon-check-2 text-success mr-2"></i> Número de Cadastro de Pessoas Físicas;</li>
                <li><i class="tim-icons icon-check-2 text-success mr-2"></i> PIS;</li>
              </ul>
              <p>
                3.1.1. Os dados de pessoas físicas como Biometria Facial não são partilhados com terceiros e ficam armazenados em banco de dados a contar do desligamento da empresa por 5 anos consecutivos.
              </p>
              <p>
                3.2. Com o seu consentimento, o REP671 pode recolher, entre outros, os seguintes dados pessoais dos Usuários Empregadores:
              </p>
              <ul class="list-unstyled pl-4">
                <li><i class="tim-icons icon-check-2 text-success mr-2"></i> Razão Social ou Denominação;</li>
                <li><i class="tim-icons icon-check-2 text-success mr-2"></i> Nome Fantasia;</li>
                <li><i class="tim-icons icon-check-2 text-success mr-2"></i> Número do Cadastro Nacional de Pessoas Jurídicas;</li>
                <li><i class="tim-icons icon-check-2 text-success mr-2"></i> Sede para fins fiscais;</li>
                <li><i class="tim-icons icon-check-2 text-success mr-2"></i> Nome do representante legal; e</li>
                <li><i class="tim-icons icon-check-2 text-success mr-2"></i> Número de Cadastro de Pessoas Físicas do representante legal.</li>
              </ul>
              <p>
                3.2.1. Os seus dados poderão ser partilhados para cumprir obrigação legal ou contratual, para aperfeiçoar nossos produtos ou serviços.
              </p>
              <p>
                3.3. Os dados pessoais poderão ser utilizados, com o consentimento dos usuários, para emitir relatórios, mapas e notificações aos Usuários, além do disposto no ponto “COOKIES E WEB BEACONS” no ponto 4 do presente termo.
              </p>
              <p>
                3.4. Os dados serão mantidos pelo REP671 durante a vigência da relação com os usuários na plataforma e, posteriormente a isso, apenas dentro do prazo legal estabelecido, que hoje é de 5 anos.
              </p>
            </section>

            <section class="mb-4">
              <h4 class="text-dark">4. Cookies e web beacons</h4>
              <p>
                4.1. Cookies são uma cadeia de texto, arquivada num ficheiro específico e incluída em pedidos e respostas do protocolo de transferência de hipertexto (HTTP – Hypertext Transfer Protocol), que permitem o registo das informações enquanto o usuário navega em um determinado sítio da internet.
              </p>
              <p>
                4.2. Utilizamos cookies para auxiliar na performance da plataforma e no armazenamento de informações para melhorar sua experiência conosco. Isto poderá incluir um simples popup (que é uma janela utilizada para abrir alguma informação extra), uma propaganda ou uma ligação em vários serviços que providenciamos, tais como fóruns.
              </p>
              <p>
                4.3. É escolha do usuário aceitar ou não a instalação de cookies, bloqueando ou eliminando os cookies instalados no seu computador ou no seu dispositivo móvel. O usuário pode deletá-los por meio do link <a href="http://tools.google.com/dlpage/gaoptout" target="_blank">http://tools.google.com/dlpage/gaoptout</a>, diretamente nas opções do seu browser, ou efetuando alterações nas ferramentas de programas antivírus. No entanto, isso poderá alterar a forma como interage com a nossa plataforma.
              </p>
              <p>
                4.4. Para obter mais informações sobre cookies, inclusive para saber que cookies foram instalados e de qual forma podem ser geridos ou eliminados, visite <a href="https://www.allaboutcookies.org" target="_blank">www.allaboutcookies.org</a>.
              </p>
              <p>
                4.5. Além disso, utilizamos anúncios publicitários de terceiros no nosso website, que poderão utilizar cookies ou web beacons, o que possibilita que terceiros, como o Google através da ferramenta de publicidade Google AdSense, também recebam a sua informação pessoal, como o endereço IP, o seu ISP e o seu browser. Esta função é geralmente utilizada para geotargeting (mostrar publicidade de determinada região apenas aos leitores que nela residam) ou apresentar publicidade direcionada a um tipo de utilizador.
              </p>
            </section>

            <section class="mb-4">
              <h4 class="text-dark">5. Ligações a serviços de terceiros</h4>
              <p>
                5.1. O REP671 possui ligações a serviços terceirizados como gateways que possuem suas próprias políticas de privacidade sobre os dados fornecidos para processamento de pagamentos. Além desses, outros fornecedores terceiros podem necessitar de informações de nossos usuários para trazer conteúdo ou serviços úteis aos visitantes, mas que somente serão enviadas em casos de extrema necessidade.
              </p>
              <p>
                5.2. Caso o usuário clique em links dentro do REP671, poderá ser redirecionado para outro site fora do nosso sistema e, portanto, fora da nossa responsabilidade, de modo que não nos responsabilizamos pela política de privacidade ou conteúdo desses serviços e recomendamos que você leia as políticas de privacidade dos mesmos.
              </p>
            </section>

            <section class="mb-4">
              <h4 class="text-dark">6. Modificações da política de privacidade</h4>
              <p>
                6.1. A qualquer momento, durante a vigência da relação entre o REP671 e o usuário, a presente Política de Privacidade poderá ser modificada, com devido aviso prévio.
              </p>
            </section>
          </div>
          <div slot="footer" class="text-center py-4">
            <base-button type="info" @click="$router.push('/')" class="btn-round">
              Página Inicial
            </base-button>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Card } from "@/components/index";

export default {
  name: "PoliticaPrivacidade",
  components: {
    Card
  }
};
</script>

<style scoped>
.card-white {
  background-color: #ffffff;
  color: #333;
  box-shadow: 0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(0, 188, 212, 0.4);
}
.content h4 {
  margin-top: 25px;
  font-weight: 600;
  border-bottom: 2px solid #f4f5f7;
  padding-bottom: 10px;
}
.content p {
  line-height: 1.8;
  font-size: 0.95rem;
  color: #525f7f;
}
.content ul li {
  margin-bottom: 8px;
  color: #525f7f;
}
a {
  color: #1d8cf8;
  text-decoration: underline;
}
a:hover {
  color: #1171d1;
}
</style>
